module.exports = "<div>Pannello Amministrativo</div>\n"